import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

const Labels = styled(Flex)`
	justify-content: space-between;
`;

const Label = styled(Box)<{ position: 'left' | 'right' }>`
	color: ${(props) =>
		props.position === 'left' ? props.theme.colors.primary : props.theme.colors.yellow};
`;

const Bar = styled.div`
	background: ${(props) => props.theme.colors.yellow};
	border-radius: 2.5px;
	height: 5px;
`;

const Fill = styled.div`
	position: relative;
	background: ${(props) => props.theme.colors.primary};
	border-radius: 4.5px;
	height: 5px;
	border: 2px solid white;
	box-sizing: content-box;
	top: -2px;
	left: -2px;
`;

export default function BinaryMetric(props: {
	value: number;
	total: number;
	labels: [string, string];
}) {
	const barWidth = props.total > 0 ? props.value / props.total : 0.5;
	const left = props.total > 0 ? props.value / props.total : 0.5;
	const right = props.total > 0 ? 1 - left : 0.5;

	return (
		<Box p={3}>
			<Labels mb={2}>
				<Label position="left">
					{props.value} ({(left * 100).toFixed(0)}%) {props.labels[0]}
				</Label>
				<Label position="right">
					{props.total - props.value} ({(right * 100).toFixed(0)}%) {props.labels[1]}
				</Label>
			</Labels>
			<Bar>
				<Fill style={{ width: `${(barWidth * 100).toFixed(2)}%` }} />
			</Bar>
		</Box>
	);
}
